<template>
    <div class="page">
        <nav-bar />
        <search-bar />

        <div class="page-content">
            <div class="p10 bg_white">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="mt10 mb10">
                    <el-breadcrumb-item :to="{ path: '/me/myInformation' }">我的文章</el-breadcrumb-item>
                    <el-breadcrumb-item>添加文章</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div style="padding: 100px" class="mt20 bg_white">
                <div class="fr ac">
                    <div class="need">文章标题</div>
                    <el-input
                        class="ml20"
                        style="width: 380px"
                        v-model="information.information_title"
                        placeholder="请输入文章标题"
                    ></el-input>
                </div>

                <div class="fr mt30">
                    <div class="need">文章内容</div>

                    <el-input
                        class="ml20"
                        rows="10"
                        style="width: 850px"
                        type="textarea"
                        resize="none"
                        placeholder="请输入文章内容"
                        v-model="information.information_desc"
                    ></el-input>
                </div>

                <div class="fr ac">
                    <div>图片</div>
                    <ky-upload
                        class="ml20"
                        :file_list.sync="information.information_imgs"
                        :limit="6"
                    ></ky-upload>
                </div>
            </div>

            <div class="fr jc ac p50">
                <el-button type="primary" style="width: 315px" @click="submit">提交</el-button>
            </div>
        </div>

        <footer-bar />
    </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import UploadImg from "@/components/UploadImg";

export default {
    props: {},
    data() {
        return {
            information: {
                information_title: "",
                information_desc: "",
                information_imgs: []
            }
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        submit() {
            let param = Object.assign({}, this.information);
            if (!param.information_title) {
                this.$message("请输入文章标题");
                return;
            }
            if (!param.information_desc) {
                this.$message("请输入文章内容");
                return;
            }

            param.information_imgs = param.information_imgs.join(",");
            this.post(
                "informationInterfaces/v1.0/insertInformation",
                param
            ).then(res => {
                this.$message("发布成功");
                setTimeout(() => {
                    this.back();
                }, 1000);
            });
        }
    },
    components: {
        "nav-bar": NavBar,
        "search-bar": SearchBar,
        "footer-bar": FooterBar,
        "ky-upload": UploadImg
    }
};
</script>

<style scoped lang="scss">
.page-content {
    width: 1200px;
    margin: 20px auto;
}

.active {
    font-size: 20px;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/page/me/myInformation/add.vue